import { useEffect, useState } from "react";
import IndoorPositioningHistory from "../../../../api/IndoorPositioningHistory";

const isAbort = (error) =>
  error?.name === "CanceledError" || error?.name === "AbortError";

// Per-subject presence strips for the scrubber. Errors are swallowed to
// empty state -- the strips are a secondary affordance, not worth a message
// popup on top of whatever the frames/alerts fetches already reported.
export const useAvailability = (machineID, range) => {
  const [subjects, setSubjects] = useState([]);
  const [intervalUsed, setIntervalUsed] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!machineID || !range) {
      setSubjects([]);
      return undefined;
    }
    const controller = new AbortController();
    setLoading(true);
    IndoorPositioningHistory.GetAvailability(
      machineID,
      range.startMs,
      range.endMs,
      controller.signal,
    )
      .then((response) => {
        if (controller.signal.aborted) return;
        if (response.code === 200 && response.data) {
          setSubjects(response.data.subjects || []);
          setIntervalUsed(response.data.intervalUsed ?? null);
        } else {
          setSubjects([]);
        }
      })
      .catch((error) => {
        if (isAbort(error)) return;
        setSubjects([]);
      })
      .finally(() => {
        if (!controller.signal.aborted) setLoading(false);
      });
    return () => controller.abort();
  }, [machineID, range?.startMs, range?.endMs]);

  return { subjects, intervalUsed, loading };
};
